<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import api from "@/axios";
import Loader from "@/router/views_mobagile/components/loader.vue";
import moment from "moment";
import Swal from "sweetalert2";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader, Layout, PageHeader, VueJsonPretty
  },
  computed: {
    ocorensNovaListColumns() {
      if (this.ocorensNovaListData && this.ocorensNovaListData.length) {
        return Object.keys(this.ocorensNovaListData[0]);
      }
      return [];
    },
    isEmissaoMaiorQue30Dias() {
      if (!this.movData || !this.movData.dtemissao) {
        return false;
      }
      const dataEmissao = moment(this.movData.dtemissao, 'DD/MM/YYYY HH:mm:ss');
      const dataAtual = moment();
      const diferencaDias = dataAtual.diff(dataEmissao, 'days');
      return diferencaDias > 30;
    }

  },
  data() {

    return {
      title: "Status de Entrega",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Status de Entrega",
          active: true
        }
      ],
      idData: 0,
      loading: true,
      movData: null,
      emitenteData: null,
      destinatarioData: null,
      empresaData: null,
      transpData: null,
      movCteData: null,
      movStatusData: null,
      ocorensData: null,
      entregaData: null,
      userLogged: null,
      modalEditarStatus: false,
      userNome: null,
      userEmail: null,
      userTipo: null,
      ocorrencia: {
        user: '',
        status: '',
        descricao: '',
        dtocorrencia: null,
        dtprevisao: null
      },
      submitted: false,

      trackerMsgssData: null,
      movElkData: null,
      rastreioDetalhesData: null,
      showModalRastreioDetalhes: false,
      ocorensNovaData: null,
      ocorensNovaListData: null,

      reprocessResponse: null,
      showReprocessModal: false,
      trackLoading: false,

      historicData: null,
      historicLoading: false,
      historicSize: 10,
      historicOrder: 'desc',
    };
  },
  created() {

  },
  mounted() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    console.log('mounted_tracking_0')
    let rota = this.$route.path
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }

    api.get(`${getBaseUrl()}api/movtrk`, {
      params: { iddata: this.idData }
    }).then((res) => {
      if (res.data.error) {
        console.log(res.data.error)
        this.$router.push(`/faltapermissao`);
      } else {
        console.log('then axios')
        console.log(res.data)
        this.movData = res.data[0]
        this.emitenteData = res.data[1]
        this.destinatarioData = res.data[2]
        this.empresaData = res.data[3]
        this.transpData = res.data[6]
        this.movCteData = res.data[7]
        this.movStatusData = res.data[8]
        this.ocorensData = res.data[9]
        this.entregaData = res.data[10]
        this.ocorrencia.user = res.data[11]
        this.userNome = this.ocorrencia.user['nome']
        this.userEmail = this.ocorrencia.user['email']
        this.userTipo = this.ocorrencia.user['tipo']
        this.trackerMsgssData = res.data[12]
        this.movElkData = res.data[13]

        if (this.movElkData){
          let ocorrensTemp = this.movElkData[0]._source.w_trk_ocorrencias
          if (this.movElkData[0]._source.w_trk_api === 'Bertolini') {
            this.ocorensNovaListData = ocorrensTemp.filter(item => item.data)
          } else {
            this.ocorensNovaListData = ocorrensTemp
          }

          this.ocorensNovaData = Object.keys(this.movElkData[0]._source)
              .filter(  key =>
                  key.startsWith('w_trk_')
                  && key !== 'w_trk_ocorrencias'
                  && this.movElkData[0]._source[key] !== undefined
                  && this.movElkData[0]._source[key] !== null
                  && this.movElkData[0]._source[key] !== '')
              .reduce((obj, key) => {
                const novoNome = key.replace(/^w_trk_/, '').split('_').map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase()).join(' ')
                if (novoNome === 'Data' || novoNome === 'Previsao Entrega' || novoNome === 'Ult Data'){
                  obj[novoNome] = this.formatDateTime(this.movElkData[0]._source[key]);
                } else {
                  obj[novoNome] = this.movElkData[0]._source[key];
                }
                return obj;
              }, {});
        }

        this.movData.dtemissao = moment(this.movData.dtemissao).format('DD/MM/YYYY HH:mm:ss')
        this.movData.dtentrega = this.movData.dtentrega ? moment(this.movData.dtentrega).format('DD/MM/YYYY HH:mm:ss') : null
        this.movData.dtpreventr = this.movData.dtpreventr ? moment(this.movData.dtpreventr).format('DD/MM/YYYY HH:mm:ss') : null
        this.movData.dtexped = this.movData.dtexped ? moment(this.movData.dtexped).format('DD/MM/YYYY HH:mm:ss') : null

        if (this.movCteData) {
          this.movCteData.dtemissao = this.movCteData.dtemissao ? moment(this.movCteData.dtemissao).format('DD/MM/YYYY HH:mm:ss') : null
        }


        this.idData = this.movData.id
        this.title = `Status de Entrega (${this.movData.id}) ${this.movData.codigo}`
        this.loading = false
        console.log('finalizou carrega movimento')
        this.fetchHistoric()
      }
    });

  },



  methods: {

    abrirDetalhesRastreio(){
      console.log('abrirDetalhesRastreio')
      this.showModalRastreioDetalhes = true
    },


    enviarTrackerMsgs(){
      console.log('enviarTrackerMsgs')
      this.loading = true
      api.post(`${getBaseUrl()}api/envtrackmsgs`, {
        idData: this.idData
      }).then((res) => {
        console.log('res_envia_tracker_msgs')
        console.log(res)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: res.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.atualizaPagina()
        })
      })
    },

    fetchHistoric() {
      console.log('fetchHistoric')
      if (!this.movData || !this.movData.chave) {
        console.log('Chave não disponível')
        return
      }

      this.historicLoading = true
      api.get(`${getBaseUrl()}api/movtrackhistoric`, {
        params: {
          chave: this.movData.chave,
          size: this.historicSize,
          order: this.historicOrder
        }
      }).then((res) => {
        console.log('res_historic', res.data)
        this.historicData = res.data.data || []
        this.historicLoading = false
      }).catch((err) => {
        console.error('Erro ao buscar histórico:', err)
        this.historicLoading = false
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar o histórico de rastreamento'
        })
      })
    },

    changeHistoricSize(size) {
      this.historicSize = size
      this.fetchHistoric()
    },

    toggleHistoricOrder() {
      this.historicOrder = this.historicOrder === 'asc' ? 'desc' : 'asc'
      this.fetchHistoric()
    },


    atualizaPagina() {
      window.location.reload();
    },

    atualizaStatus() {
      console.log('0000_atualizaStatus_0000')
      this.submitted = true
      if (this.ocorrencia.tipo && this.ocorrencia.status){

        const statusFinalizacao = ['entregue', 'ocorrencia']
        const isStatusFinalizacao = statusFinalizacao.includes(this.ocorrencia.status)

        if (isStatusFinalizacao) {
          Swal.fire({
            title: 'Confirmar finalização de entrega',
            text: 'Você está prestes a finalizar esta entrega. Esta ação é irreversível. Deseja realmente continuar?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#34c38f',
            cancelButtonColor: '#f46a6a',
            confirmButtonText: 'Sim, finalizar!',
            cancelButtonText: 'Cancelar'
          }).then((result) => {
            if (result.isConfirmed) {
              this.enviarAtualizacaoStatus()
            }
          })
        } else {
          this.enviarAtualizacaoStatus()
        }
      }
    },

    enviarAtualizacaoStatus() {
      api.post(`${getBaseUrl()}api/editstatus`, {
        idData: this.idData,
        ocorrenciaData: this.ocorrencia
      }).then((res) => {

        this.showModaleditarPed = false

        if(res.data.success === true){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.modalEditarStatus = false
            this.atualizaPagina()
          })
        }
        else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.modalEditarStatus = false
            this.atualizaPagina()
          })
        }
      })
    },

    downloadFile() {
      console.log('downloadFile')
      this.loading = true

      api.get(`${getBaseUrl()}api/moventrfile`, {
        responseType: 'blob',
        params: { idData: this.entregaData.id }
      }).then((res) => {
        console.log('res down')
        console.log(res)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'anexo_entrega_' + this.movData.codigo + '.jpg')
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loading = false
      }).catch((err) => {
        console.log('erro obter arquivo')
        console.log(err)

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Arquivo não disponível.",
          showConfirmButton: false,
          timer: 1500
        })

        this.loading = false

      })

    },


    abrirCte(idMovCte) {

      const routeData = this.$router.resolve(`/movcte/editar/${idMovCte}`)
      window.open(routeData.href, '_blank')

    },

    formatDate(value) {
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      return dateTime
    },

    formatDateTime(value) {
      const format = "DD/MM/YYYY HH:mm:ss"
      let dateTime = moment.utc(value).format(format);
      return dateTime
    },

    reprocessaManual(refresh) {
      console.log('reprocessaManual');
      this.showReprocessModal = true
      if (this.reprocessResponse != null && !refresh) return

      this.trackLoading = true
      api.get(`${getBaseUrl()}api/reprocessaTracking`, {
        params  : { chave: this.movData.chave }
      }).then((res) => {
        if (res.data.error) {
          console.log(res.data.error) 
        } else {
          this.reprocessResponse = res.data
          this.trackLoading = false
        }
      }).catch((err) => {
        console.log(err)
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Aguarde para reprocessar novamente!",
            showConfirmButton: false,
            timer: 5000
          })
      })
    },

    confirmarReprocessamento() {
      console.log('---confirmarReprocessamento---')

      api.get(`${getBaseUrl()}api/confirmreprocess`, {
        params  : { chave: this.movData.chave }
      }).catch((err) => {
        console.log(err)
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Aguarde para reprocessar novamente!",
            showConfirmButton: false,
            timer: 5000
          })
      }).then(() => {
        this.showReprocessModal = false
        this.atualizaPagina()
      })
    }

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="loading" style="min-height: 400px;">
    </Loader>

    <div v-if="!loading">
      <b-alert key="`alerta-transp`" show dismissible variant="danger" v-if="!transpData">
        <i class="mdi mdi-alert me-2"></i> Transportadora inexistente
      </b-alert>

      <b-alert key="`alerta-transp`" show dismissible variant="danger"
      v-if="transpData && transpData.id && !transpData.apirastreio">
        <i class="mdi mdi-alert me-2"></i>API de rastreio não definida para {{ transpData.nome }},
        favor ajustar para possibilitar rastreio.
      </b-alert>

    </div>

    <div v-if="!loading">
      <b-alert key="`alerta-transp`" show dismissible variant="danger" v-if="!transpData">
        <i class="mdi mdi-alert me-2"></i> Transportadora inexistente
      </b-alert>

      <b-alert key="alerta-rastreio-30dd" show dismissible variant="danger" v-if="isEmissaoMaiorQue30Dias">
        <i class="mdi mdi-alert me-2"></i>Esta nota fiscal possui data de emissão superior a 30 dias.
        Por esse motivo, não é possível realizar o monitoramento em tempo real junto à transportadora.
        Caso não atenda a sua demanda, entre em contato com o suporte.

      </b-alert>

    </div>

    <div v-if="!loading">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-warning" class="mx-2" @click="enviarTrackerMsgs">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Enviar Mensagem Rastreamento
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="abrirDetalhesRastreio">
                <i class="bx bx-search font-size-16 align-middle me-2"></i>
                Detalhes Movimento
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" @click="reprocessaManual(false)">
                <i class="bx bx-key font-size-16 align-middle me-2"></i>
                Consultar API
              </b-button>

            </div>
          </div>
        </div>
      </div>

    </div>


    <div v-if="!loading">

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="invoice-title">
  
  
  
  
  
  
  
  
              </div>
  
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong>Emitente:</strong>
                    <br />{{ emitenteData.nome }} <br /> {{ emitenteData.rua }}, {{ emitenteData.numero }}
                    <br /> {{ emitenteData.cidade }} - {{ emitenteData.estado }}
                  </address>
                </div>
                <div class="col-6 text-sm-end">
                  <address>
                    <strong>Destinatário:</strong>
                    <br /> {{ destinatarioData.nome }} <br /> {{ destinatarioData.rua }}, {{ destinatarioData.numero }}
                    <br /> {{ destinatarioData.cidade }} - {{ destinatarioData.estado }}
                  </address>
                </div>
              </div>
              <div class="row">
                <div class="col-6 mt-3">
                  <address>
                    <strong>Transportadora:</strong>
                    <div v-if="transpData">
                      <br /> {{ transpData.nome }} <br /> {{ transpData.cnpj }}
                    </div>
                  </address>
                </div>
                <div class="col-6 mt-3 text-sm-end">
  
  
  
  
  
  
                </div>
              </div>

              <div class="row">
                <div class="col-6 mt-3">
                  <address>
                    <strong>Observação Entrega ({{ movData.stsentr }}): </strong>
                      <br /> {{ movData.obsentr }} <br />
                  </address>
                </div>

                <div class="col-6 mt-3 text-sm-end">
                  <address v-if="entregaData">

                    <a href="javascript: void(0);" title="Download de Anexo" @click="downloadFile(entregaData.id)">
                      <strong>Entrega Aplicativo:</strong>
                      <br /> {{ formatDate(entregaData.data) }}
                      <br /> {{ entregaData.classe1 }}
                      <br /> {{ entregaData.classe2 }}
                      <br /> {{ entregaData.obs }}
                    </a>
                  </address>
                </div>
              </div>

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
  

              <div class="row">

                <div class="col-lg-2">
                  <div class="border p-3 rounded mt-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-success text-success font-size-24">
                          <i class="mdi mdi-file"></i>
                        </span>
                      </div>
                      <h5 class="font-size-14 mb-0">NF Emitida</h5>
                    </div>

                    <div class="row">
                      <div class="col-lg-12">
                        <div class="text-muted mt-3">
                          <h4>{{ movData.dtemissao }}</h4>
                          <p>Nota fiscal emitida, aguardando coleta do transportador</p>

  
                        </div>
                      </div>

  
  
  
  
  
                    </div>
                  </div>
                </div>

                <div class="col-lg-2" v-if="movData.dtexped">
                  <div class="border p-3 rounded mt-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-success text-success font-size-24">
                          <i class="mdi mdi-truck"></i>
                        </span>
                      </div>
                      <h5 class="font-size-14 mb-0">Coleta Efetuada</h5>
                    </div>

                    <div class="row">
                      <div class="col-lg-12">
                        <div class="text-muted mt-3">
                          <h4>{{ movData.dtexped }}</h4>
                          <p>Mercadoria coletada, aguardando emissão do CTe.</p>

  
                        </div>
                      </div>

  
  
  
  
  
                    </div>
                  </div>
                </div>

                <div class="col-lg-2" v-if="movCteData && movCteData.dtemissao">
                  <div class="border p-3 rounded mt-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-success text-success font-size-24">
                          <i class="mdi mdi-file-check"></i>
                        </span>
                      </div>
                      <h5 class="font-size-14 mb-0">CT-e Emitido</h5>
                    </div>

                    <div class="row">
                      <div class="col-lg-12">
                        <div class="text-muted mt-3">
                          <h4>{{ movCteData.dtemissao }}</h4>
                          <p>Aguardando envio do pedido.</p>
  
                        </div>
                      </div>

  
  
  
  
  
                    </div>
                  </div>
                </div>

                <div class="col-lg-2">
                  <div class="border p-3 rounded mt-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24">
                          <i class="mdi mdi-truck-delivery"></i>
                        </span>
                      </div>
                      <h5 class="font-size-14 mb-0">Em Trânsito</h5>
                    </div>

                    <div class="row">
                      <div class="col-lg-12">
                        <div class="text-muted mt-3">
                          <p>Material em trânsito.</p>
                          
                          
                        </div>
                      </div>

                      
                      
                      
                      
                      
                    </div>
                  </div>
                </div>

                <div class="col-lg-2"
                  v-if="movData.status === 'EFN' || movData.status === 'ENP' || movData.status === 'ECR' || movData.status === 'ECA'">
                  <div class="border p-3 rounded mt-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-success text-success font-size-24">
                          <i class="mdi mdi-check-network"></i>
                        </span>
                      </div>
                      <h5 class="font-size-14 mb-0">Entregue</h5>
                    </div>

                    <div class="row">
                      <div class="col-lg-12">
                        <div class="text-muted mt-3">
                          <h4>{{ movData.dtentrega }}</h4>
                          <p>Entrega realizada com sucesso!</p>
                          
                          
                        </div>
                      </div>

                      
                      
                      
                      
                      
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>


      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="invoice-title">
  
  
  
  
  
  
  
  
              </div>
  
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong>Número NF-e:</strong>
                    <br /> {{ movData.codigo }}
  
  
                  </address>
                </div>
                <div class="col-6 text-sm-end">
                  <address>
                    <strong>Emissão Nota Fiscal:</strong>
                    <br />{{ movData.dtemissao }}
  
  
                  </address>
                </div>
              </div>
              <div class="row">
                <div class="col-6 mt-3">
                  <address>
                    <strong>CT-e(s):</strong>


                    <br />

                    <div v-if="movCteData">
                      <a href="javascript: void(0);" @click="abrirCte(movCteData.id)">
                        <b>
                          {{ movCteData.chave }}
                        </b>
                      </a>

                    Emissão: <b> {{ movCteData.dtemissao }} </b>
                    </div>


                  </address>
                </div>
                <div class="col-6 mt-3 text-sm-end">
                  <address>
                    <strong>Previsão de Entrega:</strong>
                    <br /> {{ movData.dtpreventr }}
                    <br />
                    <br />
                  </address>
                </div>
              </div>
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              

              
              
              
              
              

              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
              
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-5">Detalhamento de Status</h4>
              <b-button variant="info" class="w-sm position-absolute end-50" @click="modalEditarStatus = true"
                        v-if="userTipo && ['admin', 'gerent', 'superv'].includes(userTipo)">
                <i class="bx bx-edit-alt d-block font-size-16"></i> Editar Status (ADMIN)
              </b-button>
              <br><br><br><br>

              

              <div class>
                <ul class="verti-timeline list-unstyled">


                  <li v-for="(ocor, index) in movStatusData" :key="index.id" class="event-list active">

                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                    </div>
                    <div class="d-flex">
                      <div class="me-3">
                        <i :class="'bx ' + ocor.imagem + ' h2 text-primary'"></i>
                      </div>
                      <div class="flex-grow-1">
                        <div>
                          <h5>{{ ocor.ocorrencia }}</h5>
                          <p class="text-muted">
                            {{ ocor.descricao }}
                          </p>

                          <p v-if="ocor.imagem">








                            <a :href="ocor.imagem" target="_blank" v-b-tooltip.hover placement="top"
                               title="Consultar Chave">
                              <i class="mdi mdi-file"> Visualizar Comprovante </i>

                            </a>


                          </p>

                        </div>
                        <span class="float-end"> {{ ocor.data }}</span>

                      </div>
                    </div>

                  </li>






                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-5">Ocorrências</h4>
              <div class>
                <ul class="verti-timeline list-unstyled">


                  <li v-for="(ocor, index) in ocorensData" :key="index.id" class="event-list active">

                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                    </div>
                    <div class="d-flex">



                      <div class="flex-grow-1">
                        <div>
                          <h5>Ocorrência: {{ ocor.codocor }}</h5>
                          <h5>Obs: {{ ocor.codobs }}</h5>
                          <p class="text-muted">
                            {{ ocor.telivre1 }}
                          </p> 
                          <p class="text-muted">
                            {{ ocor.telivre1 }}
                          </p>

                        </div>
                        <span class="float-end"> {{ ocor.datahora }}</span>

                      </div>
                    </div>

                  </li>

                  
                  
                  


                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Ocorrências (Novo)</h4>
              <div class>

                <div class="row">
                  <div v-for="(ocor, index) in ocorensNovaData" :key="index"
                       class="col-6">
                    <address>
                      <strong>{{ index }}</strong>
                      <br /> {{ ocor }}
                    </address>
                  </div>
                </div>

                <div v-if="ocorensNovaListData && ocorensNovaListData.length">
                  <ul>
                    <li v-for="(row, idx) in ocorensNovaListData" :key="idx" class="mb-3">
                      <strong>Ocorrência {{ idx + 1 }}:</strong>
                      <ul>
                        <li v-for="col in ocorensNovaListColumns" :key="col">
                          <b>{{ col }}:</b> {{ col === 'data' ? formatDateTime(row[col]) : row[col] }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="checkout-tabs" v-if="!loading">

        <b-card-text>
          <div class="card">
            <div class="card-body">
              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0 d-flex justify-content-between align-items-center flex-wrap">
                    <a v-b-toggle.accordion-historic
                       class="text-dark"
                       href="javascript: void(0);">Histórico de Rastreamento</a>
                    <div class="d-flex gap-2 align-items-center flex-wrap mt-2 mt-md-0">
                      <div class="btn-group btn-group-sm" role="group">
                        <button type="button"
                                class="btn"
                                :class="historicSize === 10 ? 'btn-primary' : 'btn-outline-primary'"
                                @click="changeHistoricSize(10)">10</button>
                        <button type="button"
                                class="btn"
                                :class="historicSize === 20 ? 'btn-primary' : 'btn-outline-primary'"
                                @click="changeHistoricSize(20)">20</button>
                        <button type="button"
                                class="btn"
                                :class="historicSize === 50 ? 'btn-primary' : 'btn-outline-primary'"
                                @click="changeHistoricSize(50)">50</button>
                        <button type="button"
                                class="btn"
                                :class="historicSize === 100 ? 'btn-primary' : 'btn-outline-primary'"
                                @click="changeHistoricSize(100)">100</button>
                      </div>
                      <button type="button"
                              class="btn btn-sm btn-secondary"
                              @click="toggleHistoricOrder()"
                              :title="historicOrder === 'desc' ? 'Ordenado por data decrescente (mais recentes primeiro)' : 'Ordenado por data crescente (mais antigos primeiro)'">
                        <i :class="historicOrder === 'desc' ? 'mdi mdi-sort-descending' : 'mdi mdi-sort-ascending'"></i>
                        {{ historicOrder === 'desc' ? 'Mais recentes' : 'Mais antigos' }}
                      </button>
                    </div>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-historic" visible accordion="my-accordion-historic" role="tabpanel">
                  <b-card-body>
                    <div class="card-body">
                      <div v-if="historicLoading" class="text-center py-4">
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Carregando...</span>
                        </div>
                      </div>

                      <div v-else-if="!historicData || historicData.length === 0" class="text-center py-4 text-muted">
                        <i class="mdi mdi-information-outline font-size-24"></i>
                        <p class="mt-2">Nenhum histórico de rastreamento encontrado</p>
                      </div>

                      <div v-else class="historic-timeline">
                        <div v-for="(item, index) in historicData"
                             :key="index"
                             class="historic-item mb-3 p-3 rounded shadow-sm"
                             :style="{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff', border: '1px solid #e9ecef' }">

                          <div class="d-flex justify-content-between align-items-start mb-3 flex-wrap">
                            <div class="d-flex gap-2 flex-wrap">
                              <span class="badge bg-primary">
                                <i class="mdi mdi-clock-outline"></i>
                                {{ item['@timestamp'] ? formatDateTime(item['@timestamp']) : 'Data não disponível' }}
                              </span>
                              <span v-if="item.loop" class="badge bg-info">
                                <i class="mdi mdi-refresh"></i>
                                Intervalo: {{ item.loop }}s
                              </span>
                              <span v-if="item.resultado"
                                    class="badge"
                                    :class="item.resultado === 'sucesso' ? 'bg-success' : 'bg-warning'">
                                <i :class="item.resultado === 'sucesso' ? 'mdi mdi-check-circle' : 'mdi mdi-alert-circle'"></i>
                                {{ item.resultado }}
                              </span>
                            </div>
                          </div>

                          <div class="row g-2">
                            <div v-if="item.descricao" class="col-12">
                              <div class="d-flex align-items-center mb-2">
                                <i class="mdi mdi-text text-primary font-size-18 me-2"></i>
                                <strong class="text-muted">Descrição:</strong>
                              </div>
                              <div class="bg-light p-3 rounded">
                                <p class="mb-0">{{ item.descricao }}</p>
                              </div>
                            </div>

                            <div v-if="item.response_api" class="col-12 mt-2">
                              <div class="d-flex align-items-center mb-2">
                                <i class="mdi mdi-api text-primary font-size-18 me-2"></i>
                                <strong class="text-muted">Retorno da API:</strong>
                              </div>
                              <div class="bg-light p-3 rounded" style="max-height: 350px; overflow-y: auto;">
                                <vue-json-pretty
                                  :data="typeof item.response_api === 'string' ? JSON.parse(item.response_api) : item.response_api"
                                  :deep="2"
                                  :showLength="true"
                                  :showLine="false"
                                />
                              </div>
                            </div>

                            <div v-if="item.chave" class="col-12 mt-3">
                              <small class="text-muted d-block"><i class="mdi mdi-key"></i> Chave:</small>
                              <code class="font-size-11">{{ item.chave }}</code>
                            </div>

                            <div v-if="item.obs_rastreio" class="col-12 mt-2">
                              <small class="text-muted d-block"><i class="mdi mdi-note-text"></i> Observação:</small>
                              <p class="mb-0 font-size-13">{{ item.obs_rastreio }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-card-text>

        <b-card-text>
          <div class="card">
            <div class="card-body">
              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-15
                       class="text-dark"
                       href="javascript: void(0);">Mensagens de Rastreamento</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-15" visible accordion="my-accordion-15" role="tabpanel">
                  <b-card-body>
                    <div class="card-body">
                      
                      
                      
                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">ID Evento</th>
                            <th scope="col">Status</th>
                            <th scope="col">Tipo</th>
                            <th scope="col">Destinatário</th>
                            <th scope="col">CNPJ Destinatário</th>
                            <th scope="col">E-mail</th>
                            <th scope="col">Telefone</th>
                            <th scope="col">Mensagem</th>
                            <th scope="col">Data Status</th>
                            <th scope="col" class="text-end">Criado</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="data in trackerMsgssData" :key="data.id">
                            <td>
                              <a href="javascript: void(0);" class="text-body fw-bold" >
                                {{ data.id }}
                              </a>
                            </td>
                            <td>
                              {{ data.tracckerevent_id }}
                            </td>
                            <td>
                              {{ data.status }}
                            </td>
                            <td>
                              {{ data.tipo }}
                            </td>
                            <td>
                              {{ data.destnome }}
                            </td>
                            <td>
                              {{ data.destcnpj }}
                            </td>
                            <td>
                              {{ data.destmail }}
                            </td>
                            <td>
                              {{ data.desttel }}
                            </td>
                            <td style="max-width: 150px;"  class="text-wrap">
                              {{ data.mensagem }}
                            </td>
                            <td>
                              {{ data.datastatus }}
                            </td>
                            <td class="text-end">
                              <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.created_at) }}
                              </span>
                              </h5>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-card-text>

      </div>



    </div>

      <b-modal v-model="modalEditarStatus" id="modal-center" centered title="Editar Status manualmente"
        title-class="font-20" hide-footer>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="ocorrencia.user" class="me-1">Usuário: </label>  
              <span id="ocorrencia.user" class="form-control">{{this.userNome}} - ({{this.userEmail}})</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mb-2">
              <label for="ocorrencia.tipo">Tipo da ocorrência</label>
              <select
                  id="ocorrencia.tipo"
                  v-model="ocorrencia.tipo"
                  class="form-control"
                  :class="{'is-invalid': submitted && !ocorrencia.tipo}">
                <option value="informativo">Informativo</option>
                <option value="entrega">Entrega</option>
                <option value="ocorrencia">Ocorrência</option>
              </select>
              <div v-if="submitted && !ocorrencia.tipo" class="invalid-feedback">
                <span>Campo tipo obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="ocorrencia.status">Status</label>
              <select
                  id="ocorrencia.status"
                  v-model="ocorrencia.status"
                  class="form-control"
                  :class="{'is-invalid': submitted && !ocorrencia.status}">
                <option value="nfeEmit">NF-e emitida</option>
                <option value="nfeCanc">NF-e cancelada</option>
                <option value="cteEmit">CT-e emitido</option>
                <option value="cteCanc">CT-e cancelado</option>
                <option value="transf">Em trânsito</option>
                <option value="entregue">Entregue</option>
                <option value="ocorrencia">Entregue com ressalva</option>
              </select>
              <div v-if="submitted && !ocorrencia.status" class="invalid-feedback">
                <span>Campo status obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label
                  class="mb-1 mt-3 fw-medium"
                  for="ocorrencia.descricao">Descrição</label>
              <textarea
                  id="ocorrencia.descricao"
                  v-model="ocorrencia.descricao"
                  class="form-control"
                  :maxlength="225"
                  rows="3"
                  placeholder="Limite de 255 caracteres."
                  :class="{'is-invalid': submitted && !ocorrencia.descricao}">
            </textarea>
              <div class="text-center">
                <p v-if="ocorrencia.descricao"
                   class="badge position-absolute"
                   :class="{ 'bg-success': ocorrencia.descricao.length !== 225, 'bg-danger': ocorrencia.descricao.length === 225 }">
                  {{ ocorrencia.descricao.length }} / 225
                </p>
              </div>
              <div v-if="submitted && !ocorrencia.descricao" class="invalid-feedback">
                <span>Campo descrição obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="ocorrencia.dtocorrencia">
                Data Ocorrência
              </label>
              <b-form-input
                  id="ocorrencia.dtocorrencia"
                  v-model="ocorrencia.dtocorrencia"
                  type="date"
                  :class="{'is-invalid': submitted && !ocorrencia.dtocorrencia}">
              </b-form-input>
            </div>
            <div v-if="submitted && !ocorrencia.dtocorrencia" class="invalid-feedback">
              <span>Campo data de ocorrencia obrigatório, favor preencher.</span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="ocorrencia.dtprevisao">
                Previsão de entrega
              </label>
              <b-form-input
                  id="ocorrencia.dtprevisao"
                  v-model="ocorrencia.dtprevisao"
                  type="date">
              </b-form-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button type="submit" variant="success" class="ms-1" @click="atualizaStatus">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Atualizar Status
            </b-button>

            <b-button variant="danger" class="ms-1" @click="modalEditarStatus = false">
              Cancelar
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal v-model="showModalRastreioDetalhes"
               size="xl"
               id="modal-center" centered title="Detalhes do Movimento"
        title-class="font-20" hide-footer>
        <div class="row">
          <div class="text-end mt-5">
            <vue-json-pretty :data="movElkData" :showLength="true" />

            <b-button variant="danger" class="ms-1" @click="showModalRastreioDetalhes = false">
              Fechar
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal 
        v-model="showReprocessModal"
        size="xl"
        id="modal-center" centered 
        :title="'Retorno da API tracking - ' + movData?.stsentr"
        title-class="font-20" hide-footer
      >
        <div class="row">
          <div class="text-end mt-5">
            <Loader v-if="trackLoading" style="min-height: 400px;">
            </Loader>
            <vue-json-pretty v-else :data="reprocessResponse" :showLength="true" />

            <div class="d-flex mt-5 justify-content-between">
              <b-button variant="warning" class="mx-2" @click="reprocessaManual(true)">
                <i class="bx bx-refresh font-size-16 align-middle me-2"></i>
                Recarregar
              </b-button>
              <div class="d-flex gap-2">
                <b-button variant="success" class="ms-1" @click="confirmarReprocessamento">
                  Atualizar Status
                </b-button>

                <b-button variant="danger" class="ms-1" @click="showReprocessModal = false">
                  Fechar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

  </Layout>
</template>
